import React from "react";
import { Check } from "lucide-react";

/**
 * Generic multi-select chip picker (used for styles, demographics, ethnicities).
 * Props:
 *   options: string[]
 *   selected: string[]
 *   onToggle: (option: string) => void
 *   columns: 1 | 2 | 3 (default 2)
 *   testidPrefix: string for data-testid
 *   compact: bool — smaller rendering
 */
export default function ChipPicker({
  options, selected, onToggle, columns = 2, testidPrefix = "chip", compact = false,
}) {
  const colClass = columns === 3 ? "sm:grid-cols-3"
                  : columns === 1 ? ""
                  : "sm:grid-cols-2";
  return (
    <div className={`grid grid-cols-1 ${colClass} gap-2`} data-testid={`${testidPrefix}-picker`}>
      {options.map((s) => {
        const active = selected.includes(s);
        const slug = s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
        return (
          <button
            key={s}
            type="button"
            onClick={() => onToggle(s)}
            data-testid={`${testidPrefix}-${slug}`}
            className={`text-left rounded-sm border ${compact ? "px-2 py-1.5 text-xs" : "px-3 py-2 text-sm"} transition-all flex items-start gap-2 ${
              active
                ? "bg-zinc-900 border-zinc-900 text-white"
                : "bg-white border-zinc-200 text-zinc-700 hover:border-zinc-400"
            }`}
          >
            <div
              className={`w-4 h-4 mt-0.5 rounded-sm border flex items-center justify-center flex-shrink-0 ${
                active ? "bg-white border-white" : "border-zinc-300"
              }`}
            >
              {active && <Check className="w-3 h-3 text-zinc-900" strokeWidth={3} />}
            </div>
            <span className="leading-tight">{s}</span>
          </button>
        );
      })}
    </div>
  );
}
